import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { environment } from 'services/environment/Environment';
import { useGetAppVersion } from 'services/info';
import { useStateStorage } from 'store/state';
import { IChildrenProp } from 'types/components/components.interface';

const AppInfoProvider = ({ children }: IChildrenProp) => {
  const { t } = useTranslation();
  const { version, latestVersion, setVersion, setLatestVersion } =
    useStateStorage();
  const { api } = environment();
  const currentWebVersion = `${api.apiVersion ?? ''}`.trim();
  const apiVersion = useGetAppVersion();
  const currentApiVersion = `${apiVersion.data ?? ''}`.trim();
  const normalizedStoredVersion = `${version ?? ''}`.trim();
  const normalizedLatestVersion = `${latestVersion ?? ''}`.trim();

  useEffect(() => {
    if (!currentWebVersion) return;

    setLatestVersion(currentWebVersion);

    if (!normalizedStoredVersion) {
      setVersion(currentWebVersion);
    }
  }, [
    currentWebVersion,
    normalizedStoredVersion,
    setLatestVersion,
    setVersion,
  ]);

  const isNewVersionAvailable = !!(
    normalizedStoredVersion &&
    normalizedLatestVersion &&
    normalizedStoredVersion !== normalizedLatestVersion
  );

  const refreshWithUpdate = () => {
    if (normalizedLatestVersion) {
      setVersion(normalizedLatestVersion);
    }
    window.location.reload();
  };

  return (
    <>
      {/* {isNewVersionAvailable && (
        <div
          className='relative top-0 left-0 right-0 z-[1200] flex items-center justify-between bg-white px-[38px] py-4 shadow-md'
          style={{ minHeight: '90px' }}>
          <div className='flex items-center gap-6 pr-6'>
            <PiWarning size={32} />
            <div className='flex flex-col gap-1'>
              <p className='text-[18px] font-semibold'>
                {t('app-version-banner.title')}
              </p>
              <p className='text-[13px]'>
                {t('app-version-banner.description')}
              </p>
            </div>
          </div>
          <Button
            type='submit'
            variant={BUTTON_VARIANT.submit}
            onClick={refreshWithUpdate}>
            <Button.Text text={t('app-version-banner.action')} />
            <Button.Icon icon={<PiArrowsClockwise />} />
          </Button>
        </div>
      )} */}
      {children}
      <div className='flex gap-2 absolute bottom-0 right-2 text-[10.5px] opacity-50 hover:opacity-100 transition-all'>
        <p>
          <b>API</b> {currentApiVersion || '...'}
        </p>
        <p>
          <b>WEB</b> {currentWebVersion || normalizedStoredVersion || '...'}
        </p>
      </div>
    </>
  );
};

export default AppInfoProvider;
